import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { IntegrationType } from 'src/constants';

export const getVenuesForIntegrationType = (
  venues: IGetVenuesResponseData[] = [],
  integrationType: IntegrationType,
): IGetVenuesResponseData[] =>
  venues.filter((venue) =>
    venue.external_identifiers?.some((identifier) => identifier.external_system_integration_type === integrationType),
  );
